import React, { useEffect, useState } from "react";
import { uuid } from "@ant-design/plots/es/utils";
import { Select } from "antd";

const AppSelect = props => {
  const {
    value,
    disabled,
    loading,
    showSearch,
    optionFilterProp,
    isFilterOption,
    isFilterSort,
    options,
    onChange,
    allowClear,
    defaultValue,
    mode, // multiple | tags,
    style,
  } = props;

  const [content, setContent] = useState(
    mode === "multiple" || mode === "tags" ? [] : ""
  );

  useEffect(() => {
    setContent(value);
  }, [value]);

  return (
    <Select
      key={uuid()}
      defaultValue={defaultValue}
      value={content}
      onChange={val => {
        setContent(val);
        onChange && onChange(val);
      }}
      disabled={disabled}
      loading={loading}
      showSearch={showSearch}
      allowClear={allowClear}
      optionFilterProp={optionFilterProp}
      filterOption={(input, option) =>
        isFilterOption &&
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
      filterSort={(optionA, optionB) =>
        isFilterSort &&
        (optionA?.label ?? "")
          .toLowerCase()
          .localeCompare((optionB?.label ?? "").toLowerCase())
      }
      options={options ? options : null}
      mode={mode ? mode : undefined}
      style={style ? style : null}
    />
  );
};

export default AppSelect;
